import { useState } from 'react';
import { WellsFargoSettingsApi } from '@/api/clients/wells-fargo-settings/wells-fargo-settings.api';

export const useSyncWellsFargoWebhookSubscription = () => {
  const [loading, setLoading] = useState(false);

  const syncSubscription = async (organizationId) => {
    setLoading(true);
    try {
      return await WellsFargoSettingsApi.syncWebhookSubscription(
        organizationId,
      );
    } finally {
      setLoading(false);
    }
  };

  return { syncSubscription, loading };
};
